export const timerOnce = (callback, time, ref, ...args) => {
  if (!ref) {
    return setTimeout(callback, time, ...args);
  }

  return ref;
};
export const lerp = (from, to, t) => from * (1 - t) + to * t;
